var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Square"},[_c('div',{staticClass:"Square__container",class:'is-' + _vm.selected,on:{"click":function($event){return _vm.onClick()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }